exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[src=\"\"][data-v-65a3aebb]{display:none}", ""]);

// exports
